// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__5x2cA","white":"loader_white__kXSNA","small":"loader_small__LUigr","lds-ring":"loader_lds-ring__oCB2Y"};